<div class="gb-dialog-header">
  <h1 translate="USER_ACCOUNTS.CLIENT_ACCOUNTS"></h1>
  <button mat-icon-button mat-dialog-close>
    <gb-icon icon="close"></gb-icon>
  </button>
</div>

<div class="gb-dialog-content">
  <div class="campaign-list-container">
    @for (clientAccount of clientAccounts; track clientAccount.uuid) {
      <div class="org-block" (click)="goToClientAccount(clientAccount.uuid, $event); $event.stopPropagation()">
        <div class="org-label">
          <span class="name">{{ clientAccount.name }}</span>
        </div>
      </div>
    }
  </div>
</div>
